import { IOption } from '../IOption';
import _ from 'lodash';

export const typesToOptions = <T extends string>(types: T[], record: Record<T, string>): IOption<T>[] => {
	const x = types.map<IOption<T>>(t => ({ id: t, identifier: record[t] }));
	const y = _.orderBy(x, t => t.identifier);
	return y;
};
